import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';

import {
    getInvoiceDetailsComments,
    setInvoiceDetailsError,
} from "../../../../constants/model-reducers/external/invoice/invoice/invoice-comments.settings";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, getLocalTimeZone } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    InvoiceDetailsComments: [],
});

const initialState = defaultState();

export const invoiceCommentActions = {
    postInvoiceDetailsComments: (invoiceID, filename, fileData, comment) => async (dispatch, state) => {

        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("InvoiceID", invoiceID);

        var res = await httpPostFile('external/invoice/setInvoiceDetailComments', formData);

        if (res != null) {
            dispatch({
                type: getInvoiceDetailsComments,
                InvoiceDetailsComments: res,
                isInvoiceCommentLoaded: true,
                isInvoiceCommentError: false
            });
        } else {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });
        }
    },

    getInvoiceDetailsComments: (invoiceID) => async (dispatch, state) => {
        var res = await httpGet('external/invoice/getInvoiceDetailComments?invoiceID=' + invoiceID + '&timeZone=' + getLocalTimeZone());

        if (res != null) {
            dispatch({
                type: getInvoiceDetailsComments,
                InvoiceDetailsComments: res,
                isInvoiceCommentLoaded: true,
                isInvoiceCommentError: false
            });
        } else {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });
        }
    },

    deleteInvoiceDetailsComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/invoice/invoiceDeleteComment/' + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: getInvoiceDetailsComments,
                InvoiceDetailsComments: res,
                isInvoiceCommentLoaded: true,
                isInvoiceCommentError: false
            });
        } else {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });

        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceDetailsComments: {
            return {
                ...state,
                InvoiceDetailsComments: action.InvoiceDetailsComments
            };
        }
        case setInvoiceDetailsError: {
            return {
                ...state,
                isInvoiceCommentError: action.isInvoiceCommentError,
                isInvoiceCommentLoaded: action.isInvoiceCommentLoaded
            }
        }
        default:
            return state;
    }
}